<ihd-dialog-title>{{config.title | translate}}</ihd-dialog-title>
<ihd-dialog-body>
   <div class="mb-5"> {{config.content | translate: config.contentParams}}</div>
    <div class="ml-6 mr-6" [formGroup]="datetimeForm" [ihdFormSubmitted]="submitted">
        <ihd-datetime ihdAutoFocus
                      formControlName="datetime"></ihd-datetime>

        <ihd-form-messages [form]="datetimeForm" name="datetime" [submitted]="submitted">
            <ihd-form-message name="maxDatetime">{{'Certificate.Expiry.Year.Validation' | translate}}</ihd-form-message>
            <ihd-form-message name="minDatetime">{{'Certificate.Expiry.Year.Validation' | translate}}</ihd-form-message>
        </ihd-form-messages>
    </div>
</ihd-dialog-body>
<ihd-dialog-actions>
    <ihd-button-group class="c-btn-group--column">
        <button ihdButton type="button"
                class="c-btn--feature c-btn--block c-btn--lg mb-2"
                [disabled]="isClosing"
                (click)="submit()">
            {{'Common.Confirm'|translate}}
        </button> 
        <button ihdButton type="button"
                class="c-btn--link-primary c-btn--block c-btn--lg"
                ihdDialogClose
                [disabled]="isClosing">
            {{'Common.Cancel'|translate}}
        </button>
        
    </ihd-button-group>
</ihd-dialog-actions>
